import React from "react";
import {
  FormControl,
  FormLabel,
  FormControlLabel,
  Radio,
  Typography
} from "@mui/material";
import { Field } from "formik";
import { RadioGroup as FormikRadioGroup } from "formik-mui";
import PropTypes from "prop-types";
import makeStyles from "@mui/styles/makeStyles";

const useStyles = makeStyles(theme => ({
  root: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginTop: theme.spacing(-2),
    flexWrap: "wrap"
  },
  radioGroup: {
    flexWrap: ({ noWrap }) => (noWrap ? "nowrap" : "wrap")
  },
  label: {
    paddingRight: theme.spacing(3),
    marginTop: theme.spacing(2)
  },
  radio: {
    marginTop: theme.spacing(2)
  }
}));

// must be a descendent of a Formik component
const RadioGroup = ({
  radioButtons,
  name,
  label,
  disabled,
  onClick,
  noWrap
}) => {
  const classes = useStyles({ noWrap });
  return (
    <FormControl fullWidth className={classes.root} disabled={disabled}>
      {label && (
        <FormLabel className={classes.label}>
          <Typography variant="subtitle2" color="textPrimary">
            {label}
          </Typography>
        </FormLabel>
      )}
      <Field
        type="text"
        variant="filled"
        component={FormikRadioGroup}
        name={name}
        row
        className={classes.radioGroup}
      >
        {radioButtons.map((radioBtn, index) => (
          <FormControlLabel
            key={index}
            value={radioBtn.value}
            control={<Radio color="primary" onClick={onClick} />}
            label={radioBtn.label}
            className={classes.radio}
            disabled={radioBtn.disabled}
          />
        ))}
      </Field>
    </FormControl>
  );
};

RadioGroup.propTypes = {
  fieldName: PropTypes.string,
  label: PropTypes.node,
  radioButtons: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.node,
      value: PropTypes.string
    })
  )
};
export default RadioGroup;
